export default __webpack_public_path__ + "static/media/wbk-logo.10a7d62f.jpg";